import axios from '@/shared/api/axios';

interface GetAccountCodesResponse {
    cId: string;
    period: number;
    actGrp: string;
}

export const getAccountCodes = async (payload: GetAccountCodesResponse) => {
    const response = await axios.get('/v1/accounting/accounts', { params: payload });
    return response.data;
};

export default getAccountCodes;